export default {"src":"/_next/static/media/manual-review.68bc4cd7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};